// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Post-login onboarding  (delivery location step)
// Delivery-address API (GET/POST/PUT/DELETE /api/me/addresses → customers/{uid}/addresses). Max 10 per
// customer; the first is the default, deleting the default promotes another. Instructions are courier *requests*, not guarantees.
// ─────────────────────────────────────────────────────────────────────────────
import { apiAuthed } from "./api";

export type AddressLabel = "home" | "work" | "other";

export interface DeliveryInstructions {
  leaveWithSecurity: boolean;
  directHandover: boolean;
  whatsappBeforeArrival: boolean;
}

export interface AddressInput {
  label: AddressLabel;
  house: string;
  street: string;
  landmark?: string;
  city: string;
  state: string;
  pincode: string;
  lat: number;
  lng: number;
  instructions: DeliveryInstructions;
  makeDefault?: boolean;
}

export interface Address extends Omit<AddressInput, "landmark" | "makeDefault"> {
  id: string;
  landmark: string | null;
  isDefault: boolean;
  createdAt: string;
}

export const fetchAddresses = () => apiAuthed<Address[]>("GET", "/me/addresses");

export const addAddress = (input: AddressInput) => apiAuthed<Address>("POST", "/me/addresses", input);

/** Matches the server's cap on saved addresses per customer. */
export const MAX_ADDRESSES = 10;

export const updateAddress = (id: string, input: AddressInput) => apiAuthed<Address>("PUT", `/me/addresses/${id}`, input);

export const setDefaultAddress = (id: string) => apiAuthed<Address>("POST", `/me/addresses/${id}/default`);

export const deleteAddress = (id: string) => apiAuthed<{ deleted: boolean }>("DELETE", `/me/addresses/${id}`);
